export default __webpack_public_path__ + "d8c62aa3f75d3ad18392560d43a2421a.woff2";